import award_1 from "./award_1.png";
import award_2 from "./award_2.png";
import award_3 from "./award_3.png";
import award_4 from "./award_4.png";
import award_5 from "./award_5.png";

export const awards = [award_1, award_2, award_3, award_4, award_5];
